import { Directive, HostBinding, Input, Output, EventEmitter, HostListener, OnDestroy } from '@angular/core';
import { Subject, Subscription, throttleTime } from 'rxjs';


@Directive({
  selector: 'button[valgDebounceButton], a[valgDebounceButton]',
})
export class ValgDebounceButtonDirective implements OnDestroy {
  @Output() debounceClick = new EventEmitter();
  @Input() debounceTime = 1000;
  private clicks = new Subject();
  private subscription: Subscription;

  @HostBinding('class')
  elementClass = 'valg-debounce-button';

  constructor() {
    this.subscription = this.clicks.pipe(throttleTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
